import { actions as ACTION } from "./types";
import { Api, ApiUrl, pageApi } from "@/services";
import store from "../index";

export const getThemeId = async () => {
  const themeRes = await pageApi.getThemeApi();
  return themeRes?.data?.themes?.edges?.[0]?.node?.id;
};

const PAGE_TYPES = {
  productpages: "GP_PRODUCT",
  articlepages: "GP_ARTICLE"
};

const handleGetPublishPage = ({ state, type, refresh }) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (refresh) {
        state.pages[type].list = [];
        state.pages[type].unpublishList = [];
      }
      const { shopInfo } = store?.state.account || {};
      const { themeId, pages } = state;
      const { size, after } = pages[type];

      if (shopInfo?.isGemPagesV7) {
        let themeID = themeId;
        if (!themeId) {
          themeID = await getThemeId();
          state.themeId = themeID;
        }
        const result = await pageApi.getThemePageApi({
          first: size,
          after: refresh ? undefined : after || undefined,
          themeID: themeID,
          where: {
            type: PAGE_TYPES[type],
            status: "PUBLISHED",
            default: false
          }
        });
        const { pageInfo, edges } = result?.data?.themePages || {};
        state.pages[type].after = pageInfo.endCursor;
        state.pages[type].limited = !pageInfo.hasNextPage;
        const pagesData = edges.map(item => ({
          ...item.node,
          title: item.node.name,
          thumbnail_url: item.node.theme?.thumbnail,
          published: false,
          is_published: true,
          updated_at: item.node.updatedAt,
          assignmentCount: item.node.themePageOnlineStoreData?.onlineStoreObjectBaseIDs?.length || 0,
          events: [""],
          type: type === "productpages" ? "template-product" : "template-collection"
        }));

        resolve(pagesData);

        for (const item of pagesData) {
          const isExisted = state.pages[type].list.find(listItem => listItem.id === item.id);
          if (!isExisted) state.pages[type].list.push(item);
        }
        //
      } else {
        const params = {
          published: 1
        };
        const res = await Api.base.get(ApiUrl.base[type], { params: params });
        if (res?.data?.pages) {
          const pages = res.data.pages;

          for (const item of pages) {
            const isExisted = state.pages[type].list.find(listItem => listItem.id === item.id);
            if (!isExisted) state.pages[type].list.push(item);
          }

          state.pages[type].limited = true;
        }
        resolve(res.data);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      reject(e);
    }
  });
};

const handleUnpublishPage = ({ state, pageType }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { shopInfo } = store?.state.account || {};
      if (shopInfo?.isGemPagesV7) {
        const { themeId, pages } = state;
        const { unpublishList } = pages[pageType];

        const result = await pageApi.unpublishPagesApi({
          themeId,
          ids: unpublishList
        });

        resolve(result.data);
      } else {
        const payload = {
          ids: state.pages[pageType].unpublishList.join(",")
        };
        if (window._webSocket && window._webSocket.connection.readyState === 1) {
          payload["isUseSocket"] = true;
        }
        const res = await Api.base.post(ApiUrl.base.downgrade.unpublish, payload);
        resolve(res.data);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      reject(e);
    }
  });
};

const actions = {
  [ACTION.GET_PUBLISHED_PAGE]({ state }, { type, refresh }) {
    return handleGetPublishPage({ state, type, refresh });
  },
  [ACTION.UNPUBLISH_PAGE]({ state }, pageType) {
    return handleUnpublishPage({ state, pageType });
  },

  [ACTION.GET_PUBLISH_PAGE_COUNT]({ state }) {
    return new Promise(async (resolve, reject) => {
      try {
        const { themeId } = state;
        let themeID = themeId;
        if (!themeId) {
          themeID = await getThemeId();
          state.themeId = themeID;
        }
        const result = await pageApi.getThemePageCountApi("GEMPAGESV7");

        if (result?.data?.themePageLimitation) {
          state.pagesPublishCount = {
            publishedPagesCount: result.data.themePageLimitation.publishedPagesCount || 0,
            publishedStaticPagesCount: result.data.themePageLimitation.publishedStaticPagesCount || 0,
            publishedProductPagesCount: result.data.themePageLimitation.publishedProductPagesCount || 0,
            publishedCollectionPagesCount: result.data.themePageLimitation.publishedCollectionPagesCount || 0,
            publishedArticlePagesCount: result.data.themePageLimitation.publishedArticlePagesCount || 0,
            publishedIndexPagesCount: result.data.themePageLimitation.publishedIndexPagesCount || 0,
            maximumPublishedPages: result.data.themePageLimitation.maximumPublishedPages || 999999,
            maximumPublishedStaticPages: result.data.themePageLimitation.maximumPublishedStaticPages || 999999,
            maximumPublishedProductPages: result.data.themePageLimitation.maximumPublishedProductPages || 10,
            maximumPublishedCollectionPages: result.data.themePageLimitation.maximumPublishedCollectionPages || 999999,
            maximumPublishedArticlePages: result.data.themePageLimitation.maximumPublishedArticlePages || 20
          };
        }
        resolve(result.data.themePageLimitation);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        reject(e);
      }
    });
  }
};
export default actions;
